module.exports = __webpack_public_path__ + "static/media/closeIcon.2badba36.png";